import { Button, styled } from '@material-ui/core';
import { ToggleButton } from '@material-ui/lab';
import { COLORS } from 'shared/constants/COLORS';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: 25,
});

export const FlexHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const CustomButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  background: theme.palette.type === 'dark' ? '#0b0f14' : 'transparent',
  border: '1px solid',
  borderColor: COLORS.PRIMARY,
  padding: '5px 25px',
  height: 40,
}));

export const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
  '&.Mui-selected': {
    color: COLORS.WHITE,
    backgroundColor: COLORS.PRIMARY,
    '&:hover': {
      color: COLORS.WHITE,
      backgroundColor: COLORS.PRIMARY,
    },
  },
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
